var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-admin-user pad"},[_c('div',{staticClass:"pad"},[_c('admin-user-form',{on:{"submitted":_vm.submitted}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }